
document.addEventListener("DOMContentLoaded", function () {
 const interval = setInterval(() => {
 const embed = document.querySelector("shopify-forms-embed");
   if (embed && embed.shadowRoot) {
     const style = document.createElement("style");
        style.textContent = `
        button._formSubmitButton_cit2d_96 {
   
}
    ._inline_1q1d2_47 ._formContainer_1q1d2_30 {
    max-width: 800px !important;
      min-height: auto !important;
}
    label {
    font-size: 14px !important;
    color: #464646 !important;
}
    button._formSubmitButton_jnbzb_106 {
    font-weight: 600 !important;
}
    div._formFieldContainer_1mxsl_5 {
    border-radius: 4px !important;
}
    ._formFieldContainer_1mxsl_5{
    position:relative;
}

/* An ::after rule here stamped Icon_Set_16.svg (a magnifying glass) into the
   right-hand side of EVERY field container, on both the contact and trade
   forms. Removed 2026-07-29 along with the textarea rule that existed only to
   reposition it. position:relative above is left in place — it is inert on its
   own and other rules may anchor to it. */

     @media screen and (max-width: 749px) {
     ._container_3eyaa_70 {
     display: block !important;
}
   }
    
      `;

      embed.shadowRoot.appendChild(style);
      clearInterval(interval);
    }
  }, 500);

});